import pkg from "../package.json";

/** SemVer from package.json — single source for Credits, Home, and API clientVersion. */
export const GAME_VERSION = pkg.version;

export const GAME_VERSION_LABEL = `v${GAME_VERSION}`;
